import { Conteiner } from './styles';

function Card({ children }) {
  return <Conteiner>{children}</Conteiner>;
}

export default Card;
